import React from 'react'
import { TrainingLoader } from 'loaders'
import TrainingDashboardContainer from 'components/TrainingDashboard/TrainingDashboardContainer'
import PropTypes from 'prop-types'

const TrainingDashboard = ({
  match: {
    params: { trainingUuid },
  },
}) => (
  <TrainingLoader
    trainingUuid={trainingUuid}
    additionalFields={[
      'players',
      'session_drills',
      'drill_categories',
      'trainings',
    ]}
    alwaysRenderChildren
    passIsLoading
  >
    <TrainingDashboardContainer />
  </TrainingLoader>
)

TrainingDashboard.propTypes = {
  match: PropTypes.shape({
      params: PropTypes.shape().isRequired,
  }).isRequired
}

export default TrainingDashboard
